import { Box, Stack, Typography, Divider, styled } from "@mui/material";
import { formatCurrency } from "../../../utils/formatters";
import { useData } from "../../../utils/useData";

export type LineItem = {
    leadingRow?: boolean;
    name: string;
    lineItemTooltip?: React.ReactNode;
    price: number;
    quantityName?: string;
    quantity?: number;
    quantityTooltip?: React.ReactNode;
    indented?: boolean;
}

export type FundingRequirement = {
    name: string;
    price: number;
    fundingRequirementTooltip?: React.ReactNode;
    indented?: boolean;
}

const LineItemDivider = styled(Divider)(() => ({
    margin: "12px 0 12px 0"
}))

const EmptySpace = styled(Box)(() => ({
    height: "36px"
}))

export const StandardLineitems = ({ lineItems, fundingRequirement, total, amountDue }: { lineItems: LineItem[], fundingRequirement?: FundingRequirement, total: number, amountDue?: number }) => {
    const { employerFund } = useData();
    return (
        <Box>
            <Stack direction={"row"} alignItems={"center"} justifyContent={"space-between"} borderTop={"1px solid black"} borderBottom={"1px solid black"} padding={"14px 0 14px 0"} margin={"32px 0 14px 0"}>
                <Typography variant="h6">Current Fund Balance</Typography>
                <Typography fontWeight={"500"}>{formatCurrency(employerFund.data?.availableBalance.amount ?? 0)}</Typography>
            </Stack>
            {lineItems.map((lineItem) => (
                <Box key={lineItem.name} sx={{marginLeft: lineItem.indented ? "5%" : "0px"}}>
                    {lineItem.leadingRow && <EmptySpace />}
                    <Stack direction={"row"} justifyContent={"space-between"}>
                        <Typography>{lineItem.name}</Typography>
                        {lineItem.lineItemTooltip}
                        <Typography>{formatCurrency(lineItem.price)}</Typography>
                    </Stack>
                    
                    <Stack direction={"row"} justifyContent={"space-between"}>
                        <Typography>{lineItem.quantityName}</Typography>
                        <Typography>{lineItem.quantity}</Typography>
                    </Stack>
                    <LineItemDivider />
                </Box>
            ))}

            {fundingRequirement && (
                <>
                    <Stack direction={"row"} justifyContent={"space-between"} sx={{marginLeft: fundingRequirement.indented ? "5%" : "0px"}}>
                        <Typography>{fundingRequirement.name}</Typography>
                        {fundingRequirement.fundingRequirementTooltip}
                        <Typography>{formatCurrency(fundingRequirement.price)}</Typography>
                    </Stack>
                    <LineItemDivider />
                </>
            )}

            <Stack direction={"row"} justifyContent={"space-between"}>
                <Typography variant="h6">Total Required</Typography>
                <Typography>{formatCurrency(total)}</Typography>
            </Stack>
            <Stack direction={"row"} alignItems={"center"} justifyContent={"space-between"} borderTop={"1px solid black"} borderBottom={"1px solid black"} padding={"14px 0 14px 0"} margin={"32px 0 14px 0"}>
                <Typography variant="h6">Amount Due Now</Typography>
                <Typography fontWeight={"500"}>{formatCurrency(amountDue ?? 0)}</Typography>
            </Stack>
        </Box>
    )
}